<template>
  <vs-card class="w-full collapse-cstm-card">

    <!-- Yasin Quraishy
    <pre> {{ platform_customer_id }}asss</pre> -->
    <!-- {{courseSetting}} -->
    <vs-collapse 
    v-for="(eachAssignment,index) in lessonAssignment" :key="index"
    >
      <vs-collapse-item>
        <div slot="header">{{eachAssignment.title}}</div>
<!-- <pre>{{eachAssignment.assignment.questions}}</pre> -->
        <question-modal
          
          :QuestionModal="eachAssignment.questions"
          Modaltype="assignment"
          :class_id="class_id"
          :sectionType="sectionType"
          :platform_customer_id="platform_customer_id"
        ></question-modal>

        
      </vs-collapse-item>
    </vs-collapse>
  </vs-card>
</template>
<script>
import QuestionModal from './QuestionModal.vue'

export default {
  name: 'AssignmentModal',
  components: {
    QuestionModal
  },
  props: {
    lessonAssignment: {
      type: Array,
      required: true,
      default: () => []
    },
    sectionType:{
      type:Number,
      default:null
    },
    platform_customer_id:{},
    courseSetting:{},
    class_id:{
      type:Number,
      default:null
    }
  }
}
</script>